import { InvestorTagIcon } from '../../core/themes/icons/InvestorTagIcon';
import InvestorTagList from './InvestorTagList';
import InvestorTagEdit from './InvestorTagEdit';
import InvestorTagCreate from './InvestorTagCreate';

export default {
  list: InvestorTagList,
  edit: InvestorTagEdit,
  create: InvestorTagCreate,
  icon: InvestorTagIcon
};
